import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { PersonalUserData, CoiData, UserMinimalData, UserMicroData, UserMicroData_CircleDataExtended } from '../personal-user-data/personal-user-data';
import { HttpClient } from '@angular/common/http';
import { APIS } from 'src/app/apis';
import { AbstractUserCoiService } from './user-coi.abstract.service.';

@Injectable({
  providedIn: 'root'
})
export class UserCoiService implements AbstractUserCoiService  {
  private userCOIUrl = `${APIS.user}/userCOI`;
  private usersOfInterestToTeamUrl = `${APIS.user}/usersOfInterestToTeam`;
  private getUsersToExpandPersonOfInterestUrl = `${APIS.user}/getUsersToExpandPersonOfInterest`;
  private getManagersBelowUrl = `${APIS.user}/getManagersBelow`;
  private getUsersUnderNLevelsUrl = `${APIS.user}/getUsersUnderNLevels`;
  constructor(private http: HttpClient) { }
  
  getUserCOI (orgIdOverride : string, userIdOverride: string = "", retrieveRootLevelUsers: boolean = false): Observable<CoiData> {
    const url = `${this.userCOIUrl}?orgIdOverride=${orgIdOverride}&userIdOverride=${userIdOverride}&retrieveRootLevelUsers=${retrieveRootLevelUsers}`
    return this.http.get<CoiData>(`${this.userCOIUrl}?orgIdOverride=${orgIdOverride}&userIdOverride=${userIdOverride}&retrieveRootLevelUsers=${retrieveRootLevelUsers}`);
  }

  usersOfInterestToTeam(): Observable<UserMinimalData[]> {
    return this.http.get<UserMinimalData[]>(`${this.usersOfInterestToTeamUrl}`);
  }

  getUsersToExpandPersonOfInterest(): Observable<UserMicroData_CircleDataExtended[]>{
    return this.http.get<UserMicroData_CircleDataExtended[]>(`${this.getUsersToExpandPersonOfInterestUrl}`);
  }

  getManagersBelow(orgIdOverride: string): Observable<UserMicroData[]> {
    return this.http.get<UserMicroData[]>(`${this.getManagersBelowUrl}?orgIdOverride=${orgIdOverride}`);
  }

  getUsersUnderNLevels(userIdOverride: string, nLevels : number): Observable<UserMicroData_CircleDataExtended[]> {
    return this.http.get<UserMicroData_CircleDataExtended[]>(`${this.getUsersUnderNLevelsUrl}?userIdOverride=${userIdOverride}&nLevels=${nLevels}`);
  }
}

